var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_97_graduation",
    "data-name": "#97_graduation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.18,210.46H37.63a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H360.18a.5.5,0,0,1,.5.5A.51.51,0,0,1,360.18,210.46Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.44,
    y: 154.14,
    width: 106.78,
    height: 55.82,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,210.46H48.44a.5.5,0,0,1-.5-.5V154.14a.5.5,0,0,1,.5-.5H155.22a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,155.22,210.46Zm-106.28-1H154.72V154.64H48.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.44,
    y: 154.14,
    width: 106.78,
    height: 3.38,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,158H48.44a.5.5,0,0,1-.5-.5v-3.37a.5.5,0,0,1,.5-.5H155.22a.5.5,0,0,1,.5.5v3.37A.5.5,0,0,1,155.22,158ZM48.94,157H154.72v-2.37H48.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.3,
    y: 143.93,
    width: 23.07,
    height: 66.03,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,210.46H90.3a.5.5,0,0,1-.5-.5v-66a.5.5,0,0,1,.5-.5h23.06a.5.5,0,0,1,.5.5v66A.5.5,0,0,1,113.36,210.46Zm-22.56-1h22.06v-65H90.8Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.53,
    y: 139.88,
    width: 26.59,
    height: 4.05,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.12,144.42H88.53a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h26.59a.5.5,0,0,1,.5.5v4A.5.5,0,0,1,115.12,144.42Zm-26.09-1h25.59v-3H89Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.57,
    y: 197.21,
    width: 10.51,
    height: 12.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,210.46H96.57a.51.51,0,0,1-.5-.5V197.21a.51.51,0,0,1,.5-.5h10.52a.51.51,0,0,1,.5.5V210A.51.51,0,0,1,107.09,210.46Zm-10-1h9.52V197.71H97.07Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.57,
    y: 199.45,
    width: 10.51,
    height: 10.51,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,210.46H96.57a.51.51,0,0,1-.5-.5V199.45a.5.5,0,0,1,.5-.5h10.52a.5.5,0,0,1,.5.5V210A.51.51,0,0,1,107.09,210.46Zm-10-1h9.52V200H97.07Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.83,
    y: 163.99,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,172.24H55.83a.5.5,0,0,1-.5-.5V164a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,61.27,172.24Zm-4.94-1h4.44v-6.75H56.33Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.09,
    y: 163.99,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,172.24H67.09a.51.51,0,0,1-.5-.5V164a.5.5,0,0,1,.5-.5h5.45a.5.5,0,0,1,.5.5v7.75A.51.51,0,0,1,72.54,172.24Zm-5-1H72v-6.75H67.59Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.36,
    y: 163.99,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8,172.24H78.36a.5.5,0,0,1-.5-.5V164a.5.5,0,0,1,.5-.5H83.8a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,83.8,172.24Zm-4.94-1H83.3v-6.75H78.86Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.83,
    y: 175.04,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,183.29H55.83a.5.5,0,0,1-.5-.5V175a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,61.27,183.29Zm-4.94-1h4.44v-6.75H56.33Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.09,
    y: 175.04,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,183.29H67.09a.51.51,0,0,1-.5-.5V175a.5.5,0,0,1,.5-.5h5.45a.5.5,0,0,1,.5.5v7.75A.51.51,0,0,1,72.54,183.29Zm-5-1H72v-6.75H67.59Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.36,
    y: 175.04,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8,183.29H78.36a.5.5,0,0,1-.5-.5V175a.5.5,0,0,1,.5-.5H83.8a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,83.8,183.29Zm-4.94-1H83.3v-6.75H78.86Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.83,
    y: 186.09,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,194.34H55.83a.5.5,0,0,1-.5-.5v-7.75a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,61.27,194.34Zm-4.94-1h4.44v-6.75H56.33Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.09,
    y: 186.09,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,194.34H67.09a.51.51,0,0,1-.5-.5v-7.75a.5.5,0,0,1,.5-.5h5.45a.5.5,0,0,1,.5.5v7.75A.51.51,0,0,1,72.54,194.34Zm-5-1H72v-6.75H67.59Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.36,
    y: 186.09,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8,194.34H78.36a.5.5,0,0,1-.5-.5v-7.75a.5.5,0,0,1,.5-.5H83.8a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,83.8,194.34Zm-4.94-1H83.3v-6.75H78.86Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.03,
    y: 163.99,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,172.24H120a.5.5,0,0,1-.5-.5V164a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,125.47,172.24Zm-4.94-1H125v-6.75h-4.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.29,
    y: 163.99,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,172.24h-5.44a.5.5,0,0,1-.5-.5V164a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,136.73,172.24Zm-4.94-1h4.44v-6.75h-4.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.55,
    y: 163.99,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,172.24h-5.45a.51.51,0,0,1-.5-.5V164a.5.5,0,0,1,.5-.5H148a.5.5,0,0,1,.5.5v7.75A.51.51,0,0,1,148,172.24Zm-4.95-1h4.45v-6.75h-4.45Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.03,
    y: 175.04,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,183.29H120a.5.5,0,0,1-.5-.5V175a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,125.47,183.29Zm-4.94-1H125v-6.75h-4.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.29,
    y: 175.04,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,183.29h-5.44a.5.5,0,0,1-.5-.5V175a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,136.73,183.29Zm-4.94-1h4.44v-6.75h-4.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.55,
    y: 175.04,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,183.29h-5.45a.51.51,0,0,1-.5-.5V175a.5.5,0,0,1,.5-.5H148a.5.5,0,0,1,.5.5v7.75A.51.51,0,0,1,148,183.29Zm-4.95-1h4.45v-6.75h-4.45Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.03,
    y: 186.09,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,194.34H120a.5.5,0,0,1-.5-.5v-7.75a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,125.47,194.34Zm-4.94-1H125v-6.75h-4.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.29,
    y: 186.09,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,194.34h-5.44a.5.5,0,0,1-.5-.5v-7.75a.5.5,0,0,1,.5-.5h5.44a.5.5,0,0,1,.5.5v7.75A.5.5,0,0,1,136.73,194.34Zm-4.94-1h4.44v-6.75h-4.44Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.55,
    y: 186.09,
    width: 5.44,
    height: 7.75,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,194.34h-5.45a.51.51,0,0,1-.5-.5v-7.75a.5.5,0,0,1,.5-.5H148a.5.5,0,0,1,.5.5v7.75A.51.51,0,0,1,148,194.34Zm-4.95-1h4.45v-6.75h-4.45Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.36,205.16a.49.49,0,0,1-.49-.42,5.23,5.23,0,0,0-8.09-2.92.5.5,0,0,1-.47.1.52.52,0,0,1-.34-.34,6.18,6.18,0,0,0-3.21-3.82,6.25,6.25,0,0,0-5-.45.5.5,0,1,1-.34-.94,7.21,7.21,0,0,1,5.77.51,7.32,7.32,0,0,1,3.48,3.75,6,6,0,0,1,5.22-.41,5.79,5.79,0,0,1,3.92,4.36.51.51,0,0,1-.41.58Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37,207.18a.5.5,0,0,1-.49-.46,6.73,6.73,0,0,0-8.71-5.46.49.49,0,0,1-.41,0,.54.54,0,0,1-.26-.33,9.54,9.54,0,0,0-14.58-5.76.51.51,0,0,1-.69-.14,7.32,7.32,0,0,0-6.92-3.26,5.37,5.37,0,0,0-4.54,5.5.5.5,0,0,1-.91.33,3,3,0,0,0-2-1.19,4.54,4.54,0,0,0-3.28.75c-1.42,1-2.41,2.71-3.12,5.36a.51.51,0,0,1-.44.37.52.52,0,0,1-.5-.29,3.59,3.59,0,0,0-2.15-1.81,5.62,5.62,0,0,0-4.2.28c-2.29,1.14-3.76,3.45-5,5.76a.5.5,0,0,1-.68.21.51.51,0,0,1-.2-.68c1.33-2.46,2.91-4.92,5.45-6.18a6.64,6.64,0,0,1,5-.34,4.77,4.77,0,0,1,2.1,1.38,9.12,9.12,0,0,1,3.2-4.88,5.5,5.5,0,0,1,4-.91,4.27,4.27,0,0,1,1.74.71,6.57,6.57,0,0,1,5.36-5.36,8.29,8.29,0,0,1,7.61,3.3,10.56,10.56,0,0,1,15.57,6.09,7.47,7.47,0,0,1,6,1,7.36,7.36,0,0,1,3.55,5.51.5.5,0,0,1-.46.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,276a.52.52,0,0,1-.38-.17l-54-61.57a.5.5,0,0,1,.76-.66l54,61.57a.49.49,0,0,1,0,.7A.48.48,0,0,1,149.26,276Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35,269.61h-.12L117.66,213.28a.5.5,0,1,1,.23-1l238.57,56.31a.5.5,0,0,1-.11,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.28,64.52s8.91-10.23,13-11.93,9,6.09,8.53,7.87-17.58,11.93-17.58,11.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.25,72.85l-.12,0a.42.42,0,0,1-.28-.24l-4-7.86a.47.47,0,0,1,.06-.51c.37-.42,9-10.33,13.2-12,1.56-.65,3.34-.17,5.15,1.4,2.29,2,4.35,5.57,4,7-.45,1.81-13.73,9.81-17.78,12.21A.51.51,0,0,1,298.25,72.85Zm-3.42-8.26,3.61,7.16c8.12-4.84,16.59-10.36,16.95-11.41.2-.8-1.36-4.06-3.71-6.08-1.07-.92-2.66-1.89-4.2-1.25C303.85,54.51,296.17,63.07,294.83,64.59Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,43.1c-2.16-2.39-4.57-4.92-7.75-5.41-3.68-.56-7.47,1.81-11,.77a11.72,11.72,0,0,1-2.71-1.32c-1.72-1-3.5-2.2-4.46-4a78.73,78.73,0,0,0,0,9.47c2.61,1.51,5.44,3.08,8.45,2.79a19.47,19.47,0,0,0,4-1.1,29.07,29.07,0,0,1,7.94-1.42c2.6-.1,5.61.37,7,2.6a2.82,2.82,0,0,0,.33-1.33",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,54.35l8.31,8.26s7.47-5.54,7.39-5.55-4.58-8.31-6.36-10.91-9.54-1.1-10.25,1S148.37,54.35,148.37,54.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68,63.07a.42.42,0,0,1-.32-.13l-8.31-8.27a.42.42,0,0,1-.11-.18c-.07-.21-1.67-5.18-.91-7.44.45-1.37,2.88-2.29,5.08-2.61,1.07-.15,4.64-.48,6,1.45s3.7,6.2,5.18,8.84c.56,1,1.05,1.87,1.16,2a.38.38,0,0,1,.09.18c.09.36.09.36-7.56,6A.46.46,0,0,1,156.68,63.07Zm-7.91-9L156.72,62c2.44-1.81,5.78-4.29,6.76-5-.2-.34-.51-.89-1-1.78-1.48-2.63-3.94-7-5.14-8.77-.68-1-2.68-1.4-5.09-1.06-2.17.31-4.08,1.18-4.35,2C147.36,48.94,148.32,52.66,148.77,54.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.56,193.53s2.67,5.19,12.78,11.12,27,12.53,29.74,15.65,4.12,16.87,4.12,16.87,6.37-6.1,6.54-8.48-3.49-14.91-3.49-14.91l-36.78-32.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.2,237.63a.45.45,0,0,1-.16,0,.47.47,0,0,1-.3-.38c0-.14-1.44-13.65-4-16.63-1.45-1.67-7.61-4.6-14.12-7.69-5.18-2.46-11.05-5.25-15.5-7.86-10.11-5.92-12.85-11.08-13-11.3a.46.46,0,0,1,.1-.54L245.15,181a.46.46,0,0,1,.62,0l36.78,32.44a.41.41,0,0,1,.14.21c.15.52,3.69,12.64,3.51,15.07s-6,8.14-6.69,8.78A.46.46,0,0,1,279.2,237.63Zm-46.06-44c.73,1.16,3.92,5.65,12.43,10.63,4.42,2.59,10.27,5.37,15.43,7.82,6.89,3.27,12.85,6.1,14.42,7.93,2.37,2.74,3.75,13,4.13,16.19,2-2,5.62-5.93,5.74-7.53.13-1.86-2.4-11.06-3.44-14.62L245.48,182Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.17,211.94c-.22.56,4.05,12.5,3.23,15.81s-4.43,7.48-4.43,7.48-2.18,4.76-.2,5.39,12.06-11.53,11.44-13.77-3.57-6.69-3.57-6.69l5.73,3.66.83-2.19s-4.64-5.22-7.47-7A28.89,28.89,0,0,0,280.17,211.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.93,241.09a.84.84,0,0,1-.29-.05,1.47,1.47,0,0,1-.94-.85c-.71-1.6.7-4.79.86-5.14a.41.41,0,0,1,.07-.11s3.55-4.13,4.34-7.3c.53-2.15-1.3-8.49-2.39-12.28-.84-2.9-.93-3.3-.83-3.58a.45.45,0,0,1,.55-.26,28.56,28.56,0,0,1,5.66,2.73c2.85,1.8,7.38,6.87,7.57,7.08a.44.44,0,0,1,.08.45l-.83,2.2a.44.44,0,0,1-.65.21l-4.06-2.59a25.94,25.94,0,0,1,2.57,5.14c.55,2-5.07,9-8.2,12C280.44,240.69,279.47,241.09,278.93,241.09Zm.41-5.62c-.41.92-1.29,3.33-.84,4.36a.63.63,0,0,0,.4.37c.16.06,1-.22,2.93-2.08,3.83-3.69,8.29-9.94,8-11.15-.6-2.14-3.49-6.52-3.52-6.57a.44.44,0,0,1,.61-.61l5.27,3.37.54-1.44c-.87-1-4.76-5.18-7.2-6.72a28.57,28.57,0,0,0-4.77-2.38c.16.61.43,1.56.7,2.5,1.19,4.12,3,10.35,2.4,12.74C283,231.07,279.77,235,279.34,235.47Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.18,200s16.43,50.75,16.43,52.72-8.21,13-8.21,13,10,.79,13.13-2.16,6.49-12,6.49-12l-8.26-62.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,266.25c-1.64,0-2.83-.09-3-.1a.47.47,0,0,1-.38-.27.45.45,0,0,1,.05-.46c3.14-4.21,8.12-11.39,8.12-12.71,0-1.52-9.83-32.27-16.4-52.58a.45.45,0,0,1,.22-.54L210.54,189a.48.48,0,0,1,.42,0,.45.45,0,0,1,.25.35l8.26,62.16a.42.42,0,0,1,0,.22c-.13.37-3.41,9.18-6.6,12.17C210.67,265.89,205.6,266.25,202.33,266.25Zm-2.06-1c2.43.11,9.49.21,11.94-2.09,2.86-2.67,5.95-10.7,6.34-11.72l-8.16-61.38-18.66,10.12c2.16,6.66,16.33,50.56,16.33,52.5S202.35,262.46,200.27,265.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.82,250s-5.34,12.27-8.06,13.79-10.67.93-10.67.93-5.37,2.22-4.38,4,15.34,1.87,18.59-.39a13.63,13.63,0,0,0,4.52-6.3l.69,6.89,2.65.09s1.68-9.83.79-12.78S218.82,250,218.82,250Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,270.5a31.1,31.1,0,0,1-6.43-.55c-1.09-.25-1.71-.57-2-1a1.37,1.37,0,0,1-.08-1.17c.59-1.7,4.26-3.27,4.68-3.44a.36.36,0,0,1,.2,0c.08,0,7.84.57,10.42-.87,2.13-1.19,6.41-10.21,7.87-13.59a.46.46,0,0,1,.33-.26.44.44,0,0,1,.39.13c.14.13,3.34,3.38,4.24,6.4s-.7,12.58-.77,13a.44.44,0,0,1-.45.36l-2.66-.09a.44.44,0,0,1-.42-.4l-.52-5.15a13.07,13.07,0,0,1-4,4.88C212.78,269.94,208,270.5,203.7,270.5Zm-3.54-5.3c-1.44.61-3.75,1.89-4.09,2.88a.54.54,0,0,0,0,.45s.18.28,1.38.56c3.94.92,14,.7,16.57-1.11a13.26,13.26,0,0,0,4.36-6.06.44.44,0,0,1,.86.09l.65,6.5,1.88.07c.29-1.83,1.49-9.71.74-12.2a17.17,17.17,0,0,0-3.58-5.57c-1.13,2.55-5.48,12-8,13.4C208.3,265.7,201.16,265.26,200.16,265.2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.34,86.07a11.12,11.12,0,0,1-.94,9.17,24.47,24.47,0,0,1-13.26,11,28.94,28.94,0,0,1-12.91,1.48A24.6,24.6,0,0,1,206.29,100a17,17,0,0,1-4.72-10.31c-.19-3.86,1.63-7.92,5-9.78,1.61-.88,3.69-1.45,4.29-3.19.5-1.46-.35-3-.44-4.57-.12-2.1,1.18-4,2.65-5.55,3.42-3.57,7.24-5.37,12.35-4.68,4.67.62,8.65,3.72,11.8,7.06,1.39,1.47,2.83,3,3.32,5,.24,1,.23,2,.5,2.9.93,3.36,4.74,5,6.62,7.93A7.89,7.89,0,0,1,248.34,86.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,108.39a24.73,24.73,0,0,1-3.24-.2A25.17,25.17,0,0,1,206,100.26a17.45,17.45,0,0,1-4.85-10.6,11.09,11.09,0,0,1,5.25-10.2c.37-.2.75-.38,1.14-.57,1.31-.62,2.53-1.2,2.94-2.36a4.74,4.74,0,0,0-.16-2.64,10.27,10.27,0,0,1-.3-1.76c-.11-1.88.82-3.87,2.77-5.9,3.78-3.94,7.84-5.47,12.74-4.82,4.06.55,8,2.9,12.08,7.21,1.28,1.36,2.89,3.06,3.42,5.18a12.36,12.36,0,0,1,.24,1.44,10.66,10.66,0,0,0,.26,1.45c.51,1.84,2,3.15,3.5,4.53a16.42,16.42,0,0,1,3.06,3.28,8.81,8.81,0,0,1,.72,1.4h0a11.56,11.56,0,0,1-1,9.56,24.75,24.75,0,0,1-13.51,11.24A31,31,0,0,1,224.41,108.39Zm-1.1-46.21c-3.72,0-6.84,1.49-9.9,4.68-1.77,1.84-2.62,3.6-2.52,5.22a9.61,9.61,0,0,0,.28,1.6,5.42,5.42,0,0,1,.13,3.14c-.53,1.53-2,2.23-3.4,2.9-.38.18-.75.35-1.1.54A10.1,10.1,0,0,0,202,89.61a16.53,16.53,0,0,0,4.6,10,24.28,24.28,0,0,0,14.66,7.63A28.57,28.57,0,0,0,234,105.83,24.19,24.19,0,0,0,247,95a10.61,10.61,0,0,0,.92-8.78,7.74,7.74,0,0,0-.64-1.25,15.94,15.94,0,0,0-2.9-3.09c-1.57-1.41-3.19-2.87-3.77-5a10,10,0,0,1-.28-1.59A11.18,11.18,0,0,0,240.1,74c-.47-1.89-1.92-3.42-3.2-4.78-3.91-4.14-7.68-6.41-11.53-6.92A14.76,14.76,0,0,0,223.31,62.18Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.64,93.39l53.84-35.55,10.57,18.63-53.51,39.32s-.57,9.55-3,33.72c-1.45,14.52,33,18.51,49.18,43.61,0,0-52.75,29.71-89.21,21.56-32.76-7.32-29.4-5.77-34.93-8.53L199,148s1.5-30.92.9-34.65L148.37,65l16.06-15.57L212.32,91.5Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.54,119.2s-1.4-21.31.17-25.31a9,9,0,0,1,1.77-3.07,9.16,9.16,0,0,1,4.07-2c1.76-.51,3.71-.94,5.39-.18a5.48,5.48,0,0,1,2.88,4,13.44,13.44,0,0,1-.2,5.09C231.3,104.73,218.54,119.2,218.54,119.2Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.54,119.64l-.14,0a.44.44,0,0,1-.3-.39c-.06-.87-1.39-21.45.2-25.5a7.44,7.44,0,0,1,6.13-5.36c1.91-.55,3.92-1,5.69-.17a5.9,5.9,0,0,1,3.13,4.31,13.67,13.67,0,0,1-.2,5.26c-1.32,7.08-13.66,21.13-14.18,21.72A.44.44,0,0,1,218.54,119.64Zm9.34-31a11.65,11.65,0,0,0-3.21.58,6.57,6.57,0,0,0-5.55,4.83c-1.32,3.36-.47,19.67-.21,24,2.69-3.14,12.17-14.59,13.27-20.48a13.17,13.17,0,0,0,.21-4.92A5,5,0,0,0,229.75,89,4.43,4.43,0,0,0,227.88,88.64Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,101a29.68,29.68,0,0,1,.57,6.42,164.87,164.87,0,0,0,1.72,23.18c1.17,7.7,2.86,16.25,7.55,22.67,10.66,14.59,31,11.44,31,11.44l6.67-19.55s-13.11,3.82-25.51-2.86a15.19,15.19,0,0,1-5.55-5.89c-4.47-7.57-6.13-16.84-7.73-25.37-.4-2.13-1.37-10.52-2.45-12.6a14.59,14.59,0,0,0-11.09-7.7.43.43,0,0,0-.32.05.41.41,0,0,0-.13.32l-.35,3.06A9.23,9.23,0,0,1,233.21,101Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.48,165.44c-6.73,0-19.22-1.54-26.8-11.9-4.62-6.32-6.4-14.73-7.63-22.87a164.18,164.18,0,0,1-1.73-23.24,29.42,29.42,0,0,0-.55-6.33h0a8.78,8.78,0,0,0-5.37-6.51.48.48,0,0,1-.27-.48l.35-3a.91.91,0,0,1,.31-.63.86.86,0,0,1,.65-.14,14.93,14.93,0,0,1,11.44,7.94c.85,1.62,1.6,6.76,2.1,10.15.16,1.12.3,2.05.4,2.58l.13.69c1.59,8.47,3.23,17.23,7.55,24.53a14.4,14.4,0,0,0,5.37,5.72c12.09,6.51,25,2.86,25.16,2.82a.44.44,0,0,1,.46.13.44.44,0,0,1,.1.46l-6.67,19.55a.46.46,0,0,1-.36.3A33.54,33.54,0,0,1,269.48,165.44Zm-35.82-64.55a30.23,30.23,0,0,1,.57,6.53A164.09,164.09,0,0,0,236,130.54c1.22,8,3,16.3,7.47,22.46,9.72,13.3,27.85,11.6,30.29,11.3L280,145.8c-3.1.7-14.39,2.63-25-3.1a15.57,15.57,0,0,1-5.72-6c-4.4-7.44-6.06-16.28-7.66-24.83l-.13-.69c-.1-.54-.24-1.48-.4-2.61-.46-3.14-1.23-8.38-2-9.87a14.25,14.25,0,0,0-10.68-7.45l-.31,2.69a9.61,9.61,0,0,1,5.58,7Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.48,90.82s-44-8-73.58,50.2L163,153.4s11-57.22,57.46-56.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,153.86a.42.42,0,0,1-.28-.1l-16.12-12.37a.45.45,0,0,1-.13-.57c8.47-16.66,23.69-38.37,48.13-47.14,14.65-5.26,25.83-3.33,25.94-3.31a.46.46,0,0,1,.38.45v5.84a.45.45,0,0,1-.14.32.4.4,0,0,1-.32.13h-.57c-45.11,0-56.33,55.81-56.44,56.38a.47.47,0,0,1-.29.34A.41.41,0,0,1,163,153.86Zm-15.54-13,15.24,11.71a100.59,100.59,0,0,1,11.2-28c7.81-13,22.1-28.42,46-28.42H220v-5c-2-.27-12.21-1.31-25.14,3.34C181.61,99.33,162.64,111.25,147.48,140.89Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,88.58c-1,4.74-4.67,14.79,4.78,13.28a10,10,0,0,0,2.82-1.06c5.7-2.85,6.16-6.21,6.9-12.1.32-2.56,1.2-14.46,1.2-14.46s-12.61-9.59-12.61-9.6c-.07-.22-3.62,2.26-4.72,3.65-3.52,4.45-3.25,10.48-3.21,15.88C215.21,88.75,220,88.58,220,88.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,102.46a4.88,4.88,0,0,1-3.76-1.36c-2.17-2.35-1-7.17-.15-10.69.12-.49.23-1,.33-1.39a5.7,5.7,0,0,1-3.4-1.41,4.6,4.6,0,0,1-1.34-3.44v-.91c-.05-5.12-.1-10.93,3.32-15.25.87-1.1,4.47-4,5.15-3.83a.41.41,0,0,1,.21.1h0l12.6,9.6a.43.43,0,0,1,.18.39c0,.49-.88,12-1.2,14.48-.73,5.91-1.18,9.48-7.14,12.46a10.38,10.38,0,0,1-3,1.1A12.28,12.28,0,0,1,223,102.46Zm-3-14.34a.47.47,0,0,1,.45.55c-.12.58-.28,1.24-.45,2-.81,3.32-1.91,7.87-.07,9.86.9,1,2.51,1.29,4.77.92a9.37,9.37,0,0,0,2.7-1c5.52-2.76,5.92-6,6.65-11.75.29-2.31,1.05-12.47,1.17-14.18-8.71-6.64-11.37-8.66-12.19-9.33a20.49,20.49,0,0,0-4.3,3.45c-3.23,4.07-3.17,9.46-3.12,14.67v.91A3.72,3.72,0,0,0,216.69,87,5,5,0,0,0,220,88.12Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.16,93.18a9.15,9.15,0,0,0,6.7-1.12,6.61,6.61,0,0,0,3.08-4.65s-4.64,1.93-8.92,1.17Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,93.83a10.52,10.52,0,0,1-2.16-.22.44.44,0,0,1-.33-.51l.86-4.6a.43.43,0,0,1,.51-.35c4.1.72,8.63-1.13,8.67-1.15a.44.44,0,0,1,.43,0,.44.44,0,0,1,.18.38,7,7,0,0,1-3.27,5A8.59,8.59,0,0,1,221.22,93.83Zm-1.55-1a8.54,8.54,0,0,0,5.93-1.13,6.69,6.69,0,0,0,2.76-3.61,18.34,18.34,0,0,1-8,1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.52,81.78c-.66,0-2.22-.1-2.78-1s1.86-3.81,3.41-5.35a.44.44,0,0,1,.62,0,.45.45,0,0,1,0,.63c-1.83,1.82-3.35,3.82-3.26,4.28.31.51,1.65.61,2.24.57a.46.46,0,0,1,.47.42.45.45,0,0,1-.42.47Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,85.32h0c-2.65,0-4.44-2.76-4.51-2.88a.44.44,0,1,1,.74-.48s1.61,2.47,3.77,2.47h0c1.44,0,2.85-1.06,4.21-3.16a.45.45,0,0,1,.61-.13.44.44,0,0,1,.13.62C227.3,84.12,225.64,85.32,223.88,85.32Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.52,74.53a.44.44,0,0,1-.38-.22c-.2-.34-.91-1.32-1.53-1.32h0c-.28,0-.56.24-.83.7a.45.45,0,0,1-.77-.45,1.9,1.9,0,0,1,1.6-1.13h0c1.24,0,2.19,1.58,2.3,1.76a.44.44,0,0,1-.16.6A.46.46,0,0,1,230.52,74.53Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,73.57a.53.53,0,0,1-.23-.06.45.45,0,0,1-.14-.61,3.39,3.39,0,0,1,2.13-1.58c1.15-.16,1.69,1.06,1.81,1.72a.43.43,0,0,1-.35.51.45.45,0,0,1-.52-.35s-.22-1.06-.83-1a2.55,2.55,0,0,0-1.49,1.17A.43.43,0,0,1,220,73.57Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.26,145.33a.46.46,0,0,1-.46-.44L198.61,108a.46.46,0,0,1,.44-.47.46.46,0,0,1,.47.44l1.19,36.94a.46.46,0,0,1-.44.47Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,55l-2,9.29s3.23-2.06,10.33-1.63c8.85.55,15.27,10.52,15.27,10.52l1.65-13.25S231.3,43.77,217.1,55Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.73,73.57a.43.43,0,0,1-.37-.2c-.06-.1-6.41-9.79-14.93-10.32-6.88-.42-10,1.54-10.06,1.56a.46.46,0,0,1-.49,0,.43.43,0,0,1-.18-.46l2-9.28a.54.54,0,0,1,.16-.26c4.1-3.22,8.35-4.53,12.62-3.88,7.92,1.2,13.09,8.6,13.3,8.91a.47.47,0,0,1,.08.3l-1.65,13.26a.44.44,0,0,1-.34.37ZM223.51,62.11q.93,0,2,.06c7.42.46,13.07,7.22,14.95,9.77L241.92,60c-.73-1-5.64-7.35-12.61-8.41-4-.6-8,.61-11.82,3.61l-1.74,8.24A19.77,19.77,0,0,1,223.51,62.11Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.46,63.14s-13.11-5.89-13.28-6.45c-.27-.92,20.46-11,22.41-11.44S254,60.53,254.21,61.09s.75,1.3-.38,2.12c-.75.55-16.06,4.93-16.06,4.93L229,60.82Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.77,68.58a.48.48,0,0,1-.28-.1l-8.65-7.18-10.29,2.27a.42.42,0,0,1-.27,0c-13.29-6-13.45-6.5-13.52-6.72a.78.78,0,0,1,.07-.45c1-1.66,21.35-11.28,22.67-11.55.36-.08,1.45-.29,14.27,7.62.13.07,12.55,7.77,12.85,8.48l.07.17a1.74,1.74,0,0,1-.6,2.48c-.78.57-13.63,4.26-16.2,5ZM229,60.38a.43.43,0,0,1,.28.11l8.63,7.16c5.83-1.67,15.06-4.39,15.71-4.8s.55-.87.31-1.39l0-.13c-1.36-1.27-24.05-15.64-26.15-15.64h0C226,46,208.1,54.74,205.8,56.62c1.48.92,8.31,4.08,12.71,6.06l10.35-2.29Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.87,34.5s.43,8.39-2.92,12.22-14.31,10.91-14.31,10.91L141.5,65s12-10.73,14.54-17a51.34,51.34,0,0,0,3.22-12.64S155.39,31,151.87,34.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,65.42a.46.46,0,0,1-.34-.15l-6.85-7.33a.45.45,0,0,1-.12-.37.48.48,0,0,1,.21-.33c.1-.07,10.94-7.08,14.21-10.82s2.81-11.82,2.8-11.9a.52.52,0,0,1,.14-.35,4.53,4.53,0,0,1,3.47-1.5A7.28,7.28,0,0,1,159.6,35a.44.44,0,0,1,.12.35,53.21,53.21,0,0,1-3.25,12.76c-2.58,6.29-14.17,16.72-14.67,17.16A.42.42,0,0,1,141.5,65.42Zm-6.15-7.71,6.17,6.61c1.95-1.78,11.84-11,14.1-16.52a51.91,51.91,0,0,0,3.16-12.31A6.3,6.3,0,0,0,155,33.58a3.76,3.76,0,0,0-2.66,1.1c0,1.37.13,8.71-3,12.34C146.29,50.45,137.49,56.31,135.35,57.71Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81,55.38s-2.62-5.24-6.2-5.78c0,0,4.14-3.12,4.51-6.66,5.76-1.87,6.16,1.46,6.16,4C156.28,46.92,154,53.37,151.81,55.38Z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.43,59.63c-.39,1.65.86,3.74,2,4.75,2,1.77,6.88,2.36,7.2-1.39a5.6,5.6,0,0,0-2.48-5c-2.15-1.42-5.56-1.34-6.63,1.3A3.58,3.58,0,0,0,133.43,59.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.36,66.22a6.83,6.83,0,0,1-4.21-1.49c-1.36-1.2-2.59-3.43-2.16-5.21h0a2,2,0,0,1,.13-.41,3.84,3.84,0,0,1,2.49-2.29,6,6,0,0,1,4.81.77A6.09,6.09,0,0,1,143.1,63a3.18,3.18,0,0,1-2,2.88A4.58,4.58,0,0,1,139.36,66.22Zm-5.49-6.49c-.32,1.37.73,3.3,1.88,4.31a5.51,5.51,0,0,0,5,1A2.3,2.3,0,0,0,142.19,63a5.11,5.11,0,0,0-2.27-4.59,5,5,0,0,0-4-.66A3,3,0,0,0,134,59.45l-.09.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.07,65.82a.46.46,0,0,1-.08-.91,1.64,1.64,0,0,0,1.17-1.57,3.52,3.52,0,0,0-.93-2.18,6.52,6.52,0,0,0-2-1.62,2.61,2.61,0,0,0-1.15-.34h0a1,1,0,0,0-.84.38,1.72,1.72,0,0,0-.19.64,2.31,2.31,0,0,0,0,1.34,2.51,2.51,0,0,0,1.21,1c.61.32.86.3.95.26s.17-.22.2-.36a1.59,1.59,0,0,0-.14-.94,1.65,1.65,0,0,0-.83-.94.46.46,0,0,1-.26-.59.45.45,0,0,1,.58-.27,2.5,2.5,0,0,1,1.36,1.45,2.53,2.53,0,0,1,.18,1.5,1.35,1.35,0,0,1-.71,1,2.09,2.09,0,0,1-1.76-.28A3.42,3.42,0,0,1,135.24,62a3.06,3.06,0,0,1-.12-1.89,2.41,2.41,0,0,1,.32-1,2,2,0,0,1,1.61-.81,3.6,3.6,0,0,1,1.56.45,7.3,7.3,0,0,1,2.32,1.84,4.26,4.26,0,0,1,1.14,2.79,2.5,2.5,0,0,1-1.92,2.45Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.93,49.78c-.12-.29-2.7-6.1-4-6.22s-6,1.37-5.36,1.91,4,.68,4,.68a5.88,5.88,0,0,0,0,6.23",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.52,52.84a.47.47,0,0,1-.38-.21,6.15,6.15,0,0,1-.36-6.07c-1.13-.08-2.94-.28-3.51-.74a.58.58,0,0,1-.18-.7c.39-1,4.73-2.1,5.87-2,1.72.16,4.37,6.45,4.39,6.51a.46.46,0,0,1-.25.6.47.47,0,0,1-.6-.26c-.59-1.49-2.83-5.87-3.62-5.94a13.79,13.79,0,0,0-4.65,1.27,17.47,17.47,0,0,0,3.31.41.46.46,0,0,1,.39.25.47.47,0,0,1,0,.46,5.38,5.38,0,0,0,0,5.73.45.45,0,0,1-.13.63A.46.46,0,0,1,154.52,52.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,45.61a5.31,5.31,0,0,0-1,.91,3,3,0,0,0-.5,2.68,3.65,3.65,0,0,0,1.75,2.13,1.29,1.29,0,0,0,.85.2,1.44,1.44,0,0,0,.51-.29,10.24,10.24,0,0,0,2.24-2.45,3.46,3.46,0,0,0,.69-2.46,2.68,2.68,0,0,0-1.94-1.87C147.91,44.16,147.15,45,146.37,45.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.26,52a1.88,1.88,0,0,1-.91-.28,4.1,4.1,0,0,1-2-2.4,3.46,3.46,0,0,1,.58-3.09,5.73,5.73,0,0,1,1.13-1h0c.15-.1.29-.22.43-.33a2.75,2.75,0,0,1,2.53-.89,3.09,3.09,0,0,1,2.25,2.22,3.75,3.75,0,0,1-.75,2.8,10.53,10.53,0,0,1-2.33,2.56,1.74,1.74,0,0,1-.7.37Zm-.62-6a5.12,5.12,0,0,0-1,.83,2.53,2.53,0,0,0-.41,2.26,3.21,3.21,0,0,0,1.53,1.86.79.79,0,0,0,.53.15.91.91,0,0,0,.33-.2,9.44,9.44,0,0,0,2.13-2.33,3,3,0,0,0,.63-2.12,2.24,2.24,0,0,0-1.61-1.53c-.56-.17-1,.16-1.7.72-.16.12-.31.25-.47.36Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.92,
    y1: 55.38,
    x2: 155.09,
    y2: 68.48,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,68.94a.47.47,0,0,1-.33-.14.46.46,0,0,1,0-.65l13.83-13.1a.46.46,0,0,1,.65,0,.45.45,0,0,1,0,.64L155.4,68.82A.47.47,0,0,1,155.09,68.94Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,73.54a.44.44,0,0,1-.44-.44l0-11a.44.44,0,0,1,.44-.44h0a.45.45,0,0,1,.45.44l0,11a.44.44,0,0,1-.44.44Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.08,72.1s-2,5-1.79,5,2.49.44,2.49.44Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,78h-.09c-1-.21-2.18-.42-2.37-.43a.35.35,0,0,1-.37-.16c-.21-.25-.27-.32,1.72-5.43a.43.43,0,0,1,.47-.27.43.43,0,0,1,.38.38l.69,5.43a.45.45,0,0,1-.13.38A.48.48,0,0,1,254.78,78Zm-1.95-1.26c.3.05.75.13,1.43.27l-.39-3.09C253.42,75.07,253,76.14,252.83,76.71Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.47,78.09a3.39,3.39,0,0,1,4.61-1.15,2.28,2.28,0,0,1,.83.86,2.59,2.59,0,0,1,.14,1.76,4.72,4.72,0,0,1-5.11,3.53",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.52,83.59a4.58,4.58,0,0,1-.64,0,.46.46,0,1,1,.13-.91,4.29,4.29,0,0,0,4.59-3.18,2.16,2.16,0,0,0-.1-1.45,1.9,1.9,0,0,0-.67-.69,3,3,0,0,0-4,1,.45.45,0,0,1-.62.17.46.46,0,0,1-.18-.62,3.77,3.77,0,0,1,2.36-1.73,3.69,3.69,0,0,1,2.89.42,2.83,2.83,0,0,1,1,1,3.09,3.09,0,0,1,.18,2.07A5.2,5.2,0,0,1,234.52,83.59Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.14,64.45a.52.52,0,0,1-.38-.17c-.08-.1-8.65-10-15.6-9.52s-8.92,3.84-8.94,3.88a.5.5,0,0,1-.87-.49c.09-.16,2.29-3.89,9.74-4.39s16.06,9.45,16.43,9.87a.5.5,0,0,1-.38.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.84 57.64 312.63 73.45 293.49 40.52 321.1 24.51 339.84 57.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.63,73.91a.46.46,0,0,1-.4-.23L293.09,40.75a.48.48,0,0,1,0-.35.44.44,0,0,1,.22-.28l27.62-16a.45.45,0,0,1,.34-.05.44.44,0,0,1,.28.22l18.74,33.13a.45.45,0,0,1-.17.61L312.86,73.85A.46.46,0,0,1,312.63,73.91ZM294.11,40.68l18.68,32.15,26.43-15.36L320.93,25.14Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.61,70.11l-.13,0a.5.5,0,0,1-.3-.23l-16.3-28a.49.49,0,0,1,.18-.68l22.4-13a.47.47,0,0,1,.38-.05.48.48,0,0,1,.31.23l16.29,28a.51.51,0,0,1-.18.69l-22.4,13A.55.55,0,0,1,313.61,70.11ZM298,41.75l15.79,27.17,21.54-12.51-15.8-27.18Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24,44.46a.5.5,0,0,1-.25-.93l11.13-6.47a.5.5,0,1,1,.51.87L306.49,44.4A.51.51,0,0,1,306.24,44.46Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,59.24s.86-4,1-4.83,3.4-4.12,3.94-3.54-1.75,4.81-1.75,4.81a4,4,0,0,1,1.23,4.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.44,60.39a.27.27,0,0,1-.13,0,.46.46,0,0,1-.31-.57A3.57,3.57,0,0,0,301.93,56a.44.44,0,0,1-.12-.57,18.5,18.5,0,0,0,1.77-4.15,10.14,10.14,0,0,0-3.11,3.18l-1.05,4.84-.9-.2s.87-4,1.05-4.83a9.57,9.57,0,0,1,3.93-3.92.73.73,0,0,1,.8.17c.18.2.74.79-1.52,5a4.44,4.44,0,0,1,1.1,4.47A.47.47,0,0,1,303.44,60.39Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.25,79.28a.46.46,0,0,1-.4-.23l-8.82-16a.46.46,0,1,1,.8-.44l8.82,16a.44.44,0,0,1-.18.62A.54.54,0,0,1,298.25,79.28Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,145.37a.45.45,0,0,1-.27-.08l-12.31-8.09a.5.5,0,0,1-.15-.69.51.51,0,0,1,.7-.15l12.31,8.09a.51.51,0,0,1,.14.7A.52.52,0,0,1,162.94,145.37Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,162.43a.52.52,0,0,1-.21,0,.5.5,0,0,1-.25-.66l6-13.7a.51.51,0,0,1,.66-.26.5.5,0,0,1,.26.66l-6,13.71A.49.49,0,0,1,264,162.43Z",
    fill: "#d1d3d4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.4e1c674b0342ef7ff3a1249442e7b3d6.svg";
export { ForwardRef as ReactComponent };